import { render } from "./Warehouse.vue?vue&type=template&id=fd80a71c"
const script = {}

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__